export const SECRET = '6rkcAlBhSf8h18spF0uj39lEuiRoNrv8b0cc4VF4'
